// Brand identity shown in the chrome.
//
// Handle comes from the connected Instagram account when the brand has
// one (the backend resolves it onto BrandSummary.igHandle), else a slug
// of the brand name — the same fallback Title Studio has always used.
// The link domain feeds the Stories link sticker and the Facebook Feed
// link row; it comes from the brand's own site so the preview shows a
// plausible destination rather than a placeholder.

import { useMemo } from 'react';
import { useBrand } from '../../brand/BrandContext';
import type { ChromeIdentity } from './types';

export function slugHandle(name?: string | null): string {
  const slug = String(name || 'brand').toLowerCase().replace(/[^a-z0-9._]+/g, '');
  return slug || 'brand';
}

export function useChromeIdentity(overrides?: Partial<ChromeIdentity>): ChromeIdentity {
  const { activeBrand } = useBrand();

  return useMemo(() => ({
    handle:     overrides?.handle     ?? activeBrand?.igHandle ?? slugHandle(activeBrand?.name),
    name:       overrides?.name       ?? activeBrand?.name ?? 'Brand',
    logoUrl:    overrides?.logoUrl    ?? activeBrand?.logoUrl ?? null,
    linkDomain: overrides?.linkDomain ?? activeBrand?.websiteUrl ?? null,
    ctaText:    overrides?.ctaText    ?? null
  }), [
    activeBrand?.igHandle, activeBrand?.name, activeBrand?.logoUrl, activeBrand?.websiteUrl,
    overrides?.handle, overrides?.name, overrides?.logoUrl, overrides?.linkDomain, overrides?.ctaText
  ]);
}
